<div class="col-xl payroll-list-wrap">
    <div class="employee-breadcrumb mb-3">
        <a [routerLink]="['/employee/list']">Listado de colaboradores</a> /
        <a [routerLink]="['/employee', employeeId]">Detalles del colaborador</a> /
        <span class="current">Nómina del colaborador</span>
    </div>

    <div class="d-flex align-items-center gap-3 mb-4">
        <button type="button" class="employee-back-btn" (click)="goBack()" title="Regresar">
            <i class="ti ti-arrow-left"></i>
        </button>
        <div>
            <h4 class="mb-0 employee-name">Nómina del colaborador</h4>
            <p class="employee-subtitle mb-0" *ngIf="employee">{{getEmployeeName()}}</p>
        </div>
    </div>

    <div class="row g-3 mb-4 payroll-kpi-row">
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ccf0ff;color:#00a0e1;"><i class="ti ti-file-text"></i></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Total recibos</p>
                    <p class="payroll-kpi-value">{{totalCount}}</p>
                    <p class="payroll-kpi-sublabel">En el período</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#e3fbe8;color:#3c7e43;"><i class="ti ti-circle-check"></i></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Timbrados</p>
                    <p class="payroll-kpi-value">{{stampedCount}}</p>
                    <p class="payroll-kpi-sublabel">{{stampedPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#fef3d4;color:#cf8515;"><i class="ti ti-clock"></i></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Pendientes</p>
                    <p class="payroll-kpi-value">{{pendingCount}}</p>
                    <p class="payroll-kpi-sublabel">{{pendingPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card">
                <div class="payroll-kpi-icon" style="background:#ffccce;color:#c5010b;"><i class="ti ti-alert-circle"></i></div>
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Con error</p>
                    <p class="payroll-kpi-value">{{errorCount}}</p>
                    <p class="payroll-kpi-sublabel">{{errorPercent}}% del total</p>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="payroll-kpi-card payroll-kpi-card-net">
                <div class="payroll-kpi-text">
                    <p class="payroll-kpi-label">Neto a pagar del período</p>
                    <p class="payroll-kpi-value">{{formatCurrency(netPeriodTotal)}}</p>
                    <p class="payroll-kpi-sublabel">{{totalCount}} recibos</p>
                </div>
            </div>
        </div>
    </div>

    <div class="payroll-tabs mb-0">
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'all'" (click)="setTab('all')">
            Todos <span class="payroll-tab-badge" style="background:#ccf0ff;color:#006d99;">{{totalCount}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'pending'" (click)="setTab('pending')">
            Pendientes <span class="payroll-tab-badge" style="background:#fef3d4;color:#cf8515;">{{pendingCount}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'stamped'" (click)="setTab('stamped')">
            Timbrado <span class="payroll-tab-badge" style="background:#e3fbe8;color:#3c7e43;">{{stampedCount}}</span>
        </button>
        <button type="button" class="payroll-tab" [class.active]="activeTab === 'error'" (click)="setTab('error')">
            Error <span class="payroll-tab-badge" style="background:#ffccce;color:#c5010b;">{{errorCount}}</span>
        </button>
    </div>

    <div class="payroll-panel">
        <div class="d-flex flex-wrap align-items-end gap-3 mb-3">
            <div class="employee-filter-group">
                <label class="form-label fw-bold mb-1">Periodo de pago</label>
                <input type="date" class="form-control employee-filter-control" [(ngModel)]="filterPeriod"
                    (change)="onPeriodFilterChanged()">
            </div>
        </div>

        <div class="payroll-grid ag-theme-alpine" style="height: 50vh; width: 100%;" *ngIf="!loadError">
            <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-alpine" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" [rowData]="rowData" [animateRows]="true" [context]="gridContext"
                [overlayNoRowsTemplate]="noRowsTemplate" (gridReady)="onGridReady($event)"
                (cellClicked)="onCellClicked($event)">
            </ag-grid-angular>
        </div>

        <div class="payroll-empty-state" *ngIf="loadError">
            <i class="ti ti-file-x"></i>
            <p class="mb-0">No se pudo cargar el listado de recibos de nómina.</p>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
